// extracted by mini-css-extract-plugin
module.exports = {"snapshotDetail":"snapshotDetail_snapshotDetail__oTf7h","title":"snapshotDetail_title___wwe1","detail":"snapshotDetail_detail__Ooksc","seperator":"snapshotDetail_seperator__qK00G"};